import React from 'react';
import PieLegal from '../legal/PieLegal.jsx';
import './BFooter.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

function BFooter() {
  return (
    // 🩹 CIRUGÍA: Añadimos clase principal "b-footer"
    <footer className="b-footer">
      <div className="container">

        {/* --- 🩹 CIRUGÍA: Añadimos un 'div' que será el recuadro --- */}
        <div className="b-footer-card">
          <p>&copy; 2026 Non Stop Learning Business. Todos los derechos reservados.</p>
          {/* 🩹 CIRUGÍA: 'style' en línea eliminado y reemplazado por clase */}
          <p className="b-footer-subtitle">Transformando empresas latinoamericanas con IA + Profesores Cambridge 🚀</p>
          {/* Aquí había tres enlaces que no llevaban a ninguna parte
              («#terminos», «#privacidad», «#contact»): ahora son los documentos
              de verdad (LEGAL.md, L5). */}
          <PieLegal className="b-footer-links" />
        </div>
        {/* --- 🩹 FIN DE CIRUGÍA --- */}

      </div>
    </footer>
  );
}

export default BFooter;